import DecimalType from "decimal.js";

import { Allergen, SubscriptionItemType } from "@/primary-models";

export enum FreshExtraProduct {
  SPRINKLES = "SPRINKLES",
  NIBBLES_CHICKEN = "NIBBLES_CHICKEN",
  NIBBLES_SALMON = "NIBBLES_SALMON",
}

export type TFreshExtraProduct = keyof typeof FreshExtraProduct;

export type TNibblesProduct = Extract<TFreshExtraProduct, "NIBBLES_CHICKEN" | "NIBBLES_SALMON">;

export type TSprinklesProduct = Extract<TFreshExtraProduct, "SPRINKLES">;

export type FreshExtraItemQuantity = Partial<Record<TFreshExtraProduct, number>>;

export interface IUpdateExtraItemRequest {
  subscriptionId: number;
  items: FreshExtraItemQuantity;
}

export interface IUpdateExtraItemResponse {
  subscriptionId: number;
  items: FreshExtraItemQuantity;
}

export interface INibblesUpsellRequest {
  product: TNibblesProduct;
}

export interface INibblesUpsellResponse {
  /** The subscription id to which the product was added */
  subscriptionId: number;
}

export const MAX_FRESH_EXTRAS_QUANTITIES: Record<TFreshExtraProduct, number> = {
  [FreshExtraProduct.SPRINKLES]: 10,
  [FreshExtraProduct.NIBBLES_CHICKEN]: 4,
  [FreshExtraProduct.NIBBLES_SALMON]: 4,
} as const;

export const ALLERGEN_TO_EXTRAS_MAP: Record<Allergen, TFreshExtraProduct[]> = {
  [Allergen.CHICKEN]: [
    FreshExtraProduct.SPRINKLES,
    FreshExtraProduct.NIBBLES_CHICKEN,
  ],
  [Allergen.TURKEY]: [],
  [Allergen.BEEF]: [],
  [Allergen.PORK]: [],
  [Allergen.LAMB]: [],
  [Allergen.WHITEFISH]: [],
  [Allergen.DUCK]: [],
  [Allergen.SALMON]: [
    FreshExtraProduct.NIBBLES_SALMON,
  ],
  [Allergen.TUNA]: [],
};

// This is mostly to remind us to update the fresh extra product enum when we add a new recipe.
export const IS_FRESH_EXTRA_PRODUCT: Record<TFreshExtraProduct, true>
& Record<Exclude<SubscriptionItemType, TFreshExtraProduct>, false> = {
  [SubscriptionItemType.CLUCK]: false,
  [SubscriptionItemType.GOBBLE]: false,
  [SubscriptionItemType.MOOO]: false,
  [SubscriptionItemType.OINK]: false,
  [SubscriptionItemType.QUACK]: false,
  [SubscriptionItemType.SPLASH]: false,
  [SubscriptionItemType.BAAA]: false,
  [SubscriptionItemType.SCOOP_PLANET]: false,
  [SubscriptionItemType.SCOOP_HEALTH]: false,
  [SubscriptionItemType.NIBBLES_SALMON]: true,
  [SubscriptionItemType.NIBBLES_CHICKEN]: true,
  [SubscriptionItemType.SPRINKLES]: true,
  [SubscriptionItemType.TOTE_BAG]: false,
  [SubscriptionItemType.SHREDDED_CLUCK]: false,
  [SubscriptionItemType.SHREDDED_GOBBLE]: false,
};

export function isFreshExtraProduct(product: string): product is TFreshExtraProduct {
  return !!(IS_FRESH_EXTRA_PRODUCT as Partial<Record<string, boolean>>)[product];
}

export type TExtrasPriceInfo = Record<SubscriptionItemType, DecimalType>;
